import { slugify } from '@shared/utils/strings';
import { Cluster } from './cluster.types';

export const getClusterByName = (
    data: Array<Cluster>, searchName: string,
) => Object.values(data).find(cluster => slugify(cluster.name) === slugify(searchName));

const fromEntries = arr => Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));

export const formatObjectKeysToCamelCase = obj => fromEntries(
    Object.entries(obj).map(([key, value]) => [key.replace(/_./g, str => str[1]?.toUpperCase()), value]),
);
